<script setup>
    import { onMounted } from 'vue';
    import { useInstantCredit } from '@/composables/front/checkout/useInstantCredit';
    import { useAbonoTracking } from '@/composables/front/analytics/useAbonoTracking';
    import InstantCreditStatus from '@/modules/front/checkout/instant-credit/InstantCreditStatus.vue';

    const props = defineProps({
        order: {
            type: String,
            required: true,
        },
        result: {
            type: String,
            required: true,
        },
    });

    // Source session_id from sessionStorage — same pattern as the normal compra/Bizum flow.
    // The compra process stores it via sessionStorage.setItem('session_id', ...) before
    // the PAYCOMET challenge redirect. On passive return we read it back so the paid
    // redirect yields a well-formed /compra/{session_id}/{tpv_order}?error=false URL.
    const sessionId = sessionStorage.getItem('session_id') || '';

    // For passive return, we need a minimal store/getVuexAlias setup
    // The composable will use these for telemetry
    const store = null; // Return view doesn't need store for polling
    const getVuexAlias = () => null;

    const {
        phase,
        finalState,
        polling,
        error,
        startPollingForOrder,
    } = useInstantCredit({
        sessionId,
        tipoVenta: 'abono',
        importeCarrito: 0,
        gastosGestionUnitarios: 0,
        store,
        getVuexAlias,
    });

    const tracking = useAbonoTracking({ store, getVuexAlias });

    onMounted(() => {
        // Fire telemetry based on result param
        if (props.result === 'ok') {
            tracking.trackIcReturnOkViewed();
        } else {
            tracking.trackIcReturnKoViewed();
        }

        // Start polling immediately — never assert success
        startPollingForOrder(props.order);
    });
</script>

<template>
    <div class="tw:min-h-screen tw:flex tw:items-center tw:justify-center tw:bg-gray-50">
        <div class="tw:max-w-md tw:w-full tw:p-6">
            <InstantCreditStatus
                :phase="phase"
                :final-state="finalState"
                :error="error"
                :polling="polling"
            />
        </div>
    </div>
</template>
